export default __webpack_public_path__ + "static/media/4.e6f555e4.png";